import { GivingTrendItem } from '../../../types';
import Chart from '../../shared/Chart';

interface GivingChartProps {
  data: GivingTrendItem[];
}

const GivingChart = ({ data }: GivingChartProps) => {
  return (
    <Chart
      data={data}
      bars={[
        { dataKey: 'recurring', fill: '#82ca9d', name: 'Recurring', stackId: 'a' },
        { dataKey: 'unique', fill: '#8884d8', name: 'Unique', stackId: 'a' },
      ]}
      height={250}
      ariaLabel="Giving trends chart showing recurring and unique donations over time"
    />
  );
};

export default GivingChart;
